export default {
  SET_DRAWER: 'SET_DRAWER',
};
